// extracted by mini-css-extract-plugin
export default {"root":"-WIDs1PzhBD5wH+moTeH3g==","quote":"H55hUyidRnA1Cy0YyGlKUQ==","byline":"Gmm4nGewkkUvTeXJYCj79w==","mobile":"-tKtLSfz-nnHMbKj0dkjsQ=="};